<div class="md-input-container" fxLayout.xs="column">
<div>
<mat-form-field class="mat-form-withtooltip">
    <mat-label [ngClass]="{'asterix--after': (disabled == true)}">{{labeltext}}</mat-label>
    <mat-select [ngStyle]="{'width':helptext!=''?'100%':'100%'}"  [(ngModel)]="value"
                [(value)]="value" [disabled]="disabled || isDisabled"
                (openedChange)="onOpen($event)"
            [typeaheadDebounceInterval]="300"
            [compareWith]="objectComparison"
            (selectionChange)="onCountryChange($event)"
            [panelClass]="isLoading || !isOpen ? 'hide-dummy-option' : ''"
               name="countryId"
               #countryId="ngModel"
               [required]="isRequired" 
               activeonly="activeonly">           
            <mat-option *ngIf="items === null || !items?.length" class="minh88" disabled>
                <div class="select-placeholder-container">
                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                </div>
            </mat-option>
            <mat-option [value]="-1" *ngIf="alltext && !isLoading">
                {{alltext}}
            </mat-option>
            <mat-option *ngFor="let item of items" [value]="item">{{item.Name}}</mat-option>
    </mat-select>
    <mat-error class="sm-errormsg" *ngIf="!countryId.valid && countryId.touched && isRequired">Required</mat-error>
</mat-form-field>
<mat-icon fxFlexAlign.lt-md="center"
        *ngIf="helptext!=''"
        [matTooltip]="helptext"
        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons" [ngClass]="[customcss ? 'md-iwgNavbar-escustom' : 'md-iwgNavbar-theme']">help
</mat-icon>
</div>
<mat-error class="md-errormsg"  *ngIf="!countryId.valid && countryId.touched && isRequired">Required</mat-error>
</div>


